import api from '../../api';
import { THomePage } from './homepage.types';

export const homepageURL = '/punter/content/homepage';

export const queryHomePage = () =>
  api.get<THomePage[]>(homepageURL).then((res) => res.data);
